import { Component, PLATFORM_ID, Inject, OnInit, OnChanges, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common'
import { ImageItem } from '../image-item/image-item.component';
import { RowHeader } from '../row-header/row-header.component';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
    selector: 'item-row',
    templateUrl: './row.component.html',
    styleUrls: ['./row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class Row {
    @Input() row$: any;
    @Input() size: String = "md";
    @Input() showHeader: boolean = true;
    @Input() showCopy: boolean = true;
    @Input() showCount: boolean = true;
    @Input() truncate: boolean = true;

    //private content$: any;
    private isServer: boolean;
    private style: string;
    private totalCount: number;
    private maxPerRow: number;
    private unfold: boolean;
    private showMore: boolean;
    private routeUrl: string;
    private maxItemToRetrieve: number;
    private allDataBuffer = [];
    private allLoaded : boolean = false;
    private hasData : boolean = false;
    
    /**
     * Item Row Component
     */
    constructor(
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        private coreEffects: CoreEffects,
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router : Router
    ) {
        this.isServer = isPlatformServer(this.platformId);
    }

ngOnInit() {
        this.setCellStyle();         
        if (!this.isServer) {
            this.maxItemToRetrieve = this.deviceInfo.isPhone ? this.maxPerRow  : this.maxPerRow* 2;
            const rowFlags =  (this.row$['meta']) ? this.row$['meta']['metaFlags'] : null;
            this.hasData = (rowFlags) ? rowFlags['hasData'] : this.hasData; 
            this.routeUrl = this.row$['internal_route'];
            if (this.routeUrl == null) {
                this.routeUrl = this.row$['meta'] == null ? null : this.row$['meta']['internal_route'];
            }
            if (!this.hasData && this.routeUrl) {
                const content: any = this.coreEffects.getStoreData(this.route.snapshot.params, this.routeUrl)
                this.row$ = content;
            }
            if (this.row$['data'] && this.row$['data'].length > 0) {
                this.row$["total_count"] = this.row$['meta'].total_count || this.row$['data'].length || 0;                
                this.showMore = this.truncate && this.maxPerRow && this.row$["total_count"] > this.maxItemToRetrieve;
                this.allDataBuffer = [].concat(this.row$['data']);
                if (this.showMore){
                    this.row$['data'] = this.row$['data'].slice(0, this.maxItemToRetrieve);
                }    
            }
            else{
                this.showMore = false;
            }
        }
    }

    private setCellStyle() {
        switch (this.size) {
            case "lg":
                this.style = "col-sm-6 col-md-6"
                this.maxPerRow = 2;
                break;
            case "sm":
                this.style = "col-sm-6 col-md-3"
                this.maxPerRow = 4;
                break;
            case "md":
            default:
                this.style = "col-sm-6 col-md-4"
                this.maxPerRow = 3;
                break;
        }

        if(this.deviceInfo.isPhone){
            this.style = "col-sm-6 col-md-4"
            this.maxPerRow = 4;
        }
    }
    private hasMore():boolean{
        return  (this.row$.meta && this.row$.meta.next_page_url) || (this.allDataBuffer.length > this.row$.data.length );
    }
    private hasViewAllMore():boolean{
        if (this.allDataBuffer.length > this.row$.data.length) {
            return true;
        }
        if (this.unfold && this.allDataBuffer.length == this.row$.data.length){
            return true;
        }

        return false; 
    }
    private getMore(e){
        if(this.allDataBuffer.length > this.row$['data'].length){
            this.row$['data'] = this.allDataBuffer;
        }else{  
            this.row$ = this.coreEffects
                .moreResultsBySearchTermAndCategory(this.row$);
            this.allDataBuffer = [].concat(this.row$['data']);
            
        }
    }

    //avoid a leak
    ngOnDestroy(){
//         if (this.coreEffects.moreResultsSubscription){
//             this.coreEffects.moreResultsSubscription.unsubscribe();
//         }
    }


    private viewAll(e) {
        if (!this.unfold) {
            this.row$['data'] = this.allDataBuffer;
            this.unfold = true;
        }
        else {
            this.allDataBuffer = this.row$['data'];
            this.row$['data'] = this.row$['data'].slice(0, this.maxItemToRetrieve);
            this.unfold = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/row/row.component.ts